document.addEventListener("DOMContentLoaded", function(event) {

    const burgers = [...document.querySelectorAll('.arc-header__burger')];
    const nav = document.querySelector('nav.arc-header__nav');
    const body = document.body;

    burgers.forEach((burger) => burger.onclick = (e) => {
        e.stopPropagation(); // Prevent the event from propagating to the document
        toggleBurgerMenu();
    });

    // Close the menu if clicked outside
    document.addEventListener('click', (e) => {
        if (nav.classList.contains('open') && !nav.contains(e.target) && !e.target.matches('.arc-header__burger')) {
            toggleBurgerMenu(); // Close the menu if the click is outside the menu
        }
    });

});

function toggleBurgerMenu() {
    const nav = document.querySelector('nav.arc-header__nav');
    const body = document.body;

    // Toggle the 'open' class on the navigation
    nav.classList.toggle('open');

    // Prevent scrolling when the menu is open
    if (nav.classList.contains('open')) {
        body.style.overflow = 'hidden';  // Disable scrolling
    } else {
        body.style.overflow = '';  // Enable scrolling
    }
}



// Select the header element
const header = document.querySelector('header');

// Function to add class when scrolling
function addClassOnScroll() {
    if (window.scrollY > 50) {  // Adjust the scroll threshold as needed
        header.classList.add('scrolled'); // Add class 'scrolled'

    if (header.classList.contains('violet-bg')) {        
        // Update the image source for the light background
        updateHeaderImage('/wp-content/uploads/2025/01/logo-white.svg');
    } 

    if (header.classList.contains('softpurple-bg')) {        
        // Update the image source for the light background
        updateHeaderImage('/wp-content/uploads/2025/01/logo-purple.svg');
    } 
    } else {
        header.classList.remove('scrolled'); // Remove class 'scrolled' if scrolling back up
        updateHeaderImage('/wp-content/uploads/2025/01/logo-white.svg');
    }
}

// Listen for the scroll event
window.addEventListener('scroll', addClassOnScroll);
window.addEventListener('load', addClassOnScroll);



    // Function to update the image source in the header
    function updateHeaderImage(src) {
      const existingImg = header.querySelector('img');
      if (existingImg) {
        existingImg.src = src; // Update the existing image source
      } else {
        // If no image exists, create a new one
        const imgElement = document.createElement('img');
        imgElement.src = src;
        header.appendChild(imgElement);
      }
    }
